import { useRbac } from 'shared/features/rbac';
import { Actions, Subjects } from 'constants/accessControlList';
import { usePrescribingAccessEnable } from './usePrescribingAccessEnable';
import { useExperienceState } from '../../experience-state';
export var useCanIEditPrescriptions = function () {
    var canI = useRbac().canI;
    var _a = useExperienceState(), experienceState = _a.data, isFetched = _a.isFetched;
    var prescribingAccessEnabled = usePrescribingAccessEnable(isFetched, (experienceState === null || experienceState === void 0 ? void 0 : experienceState.erx_prescribing_access) || false);
    return ((canI(Actions.Edit, Subjects.PrescriptionsMyMembers) ||
        canI(Actions.Edit, Subjects.PrescriptionsAllMembers)) &&
        prescribingAccessEnabled);
};
